import React, { useState } from 'react';
import AnimateOnScroll from '../../about/Components/AnimateOnScroll';
const FaqItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <AnimateOnScroll>
    <div className="faq-item">
      <div 
        className="faq-question" 
        onClick={onClick}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '20px 0',
          cursor: 'pointer',
          borderBottom: isOpen ? 'none' : '1px solid #333', // Only show border when closed
        }}
      >
        <h3 style={{ 
          margin: 0, 
          fontWeight: 'normal',
          fontSize: '1.1rem'
        }}>
          {question}
        </h3>
        <span style={{ 
          fontSize: '1.5rem', 
          transition: 'transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
          transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '24px',
          height: '24px',
        }}>
          {isOpen ? '×' : '+'}
        </span>
      </div>
      
      <div 
        style={{
          maxHeight: isOpen ? '1000px' : '0',
          overflow: 'hidden',
          transition: isOpen 
            ? 'max-height 0.5s ease-in-out, opacity 0.4s 0.1s, transform 0.4s ease-out' 
            : 'max-height 0.35s cubic-bezier(0.5, 0, 0.1, 1), opacity 0.25s, transform 0.3s ease-in',
          marginBottom: isOpen ? '20px' : '0',
          opacity: isOpen ? 1 : 0,
          transform: isOpen ? 'translateY(0)' : 'translateY(-8px)',
          transformOrigin: 'top',
          borderBottom: isOpen ? '1px solid #333' : 'none', // Show border when open
          paddingBottom: '15px',
        }}
      >
        <div style={{ 
          color: '#9ca3af', 
          lineHeight: '1.6',
          paddingTop: '20px',
          paddingBottom: '10px',
        }}>
          {answer}
        </div>
      </div>
    </div>
    </AnimateOnScroll>
  );
};

const FaqComponent = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqData = [
    {
      question: "How secure is PlasticAnalytics?",
      answer: "PlasticAnalytics is single tenant, SOC2 and ISO 27001 certified, and GDPR compliant. All data is encrypted at rest with AES 256 and in transit with TLS 1.2+. The platform follows data privacy regulations and guidelines to protect each individual user. Enterprise users can be authenticated with Single-Sign-On (SSO). Integrated systems can mirror the underlying system permissions."
    },
    {
      question: "Which integrations does PlasticAnalytics have?",
      answer: "PlasticAnalytics integrates with laboratory equipment systems, LIMS (Laboratory Information Management Systems), data visualization tools like Tableau and Power BI, and cloud storage solutions including AWS, Azure, and Google Cloud. We also offer API access for custom integrations with your existing enterprise systems."
    },
    {
      question: "Can PlasticAnalytics analyze physical samples?",
      answer: "PlasticAnalytics is a software platform that analyzes spectral data. While we don't physically analyze samples, our platform can process data from various spectroscopy instruments including FTIR, Raman, XRF, and others. We can recommend partner laboratories for physical sample analysis if needed."
    },
    {
      question: "Which types of data can PlasticAnalytics handle?",
      answer: "PlasticAnalytics specializes in spectral data analysis for microplastics and chemical compounds. We support common file formats from major spectroscopy instruments, including .spc, .spa, .jdx, .dx, .csv, and proprietary formats from leading manufacturers. The system can also handle metadata, images, and supporting documentation associated with your samples."
    },
    {
      question: "How does PlasticAnalytics store my data?",
      answer: "Your data is stored securely in the cloud with enterprise-grade encryption. All data is encrypted both in transit and at rest. For Enterprise customers, we offer options for data residency in specific geographic regions to meet compliance requirements. Data is backed up regularly, and we maintain strict access controls."
    },
    {
      question: "How are data permissions handled?",
      answer: "PlasticAnalytics provides granular permission controls allowing administrators to determine who can view, edit, or share specific data sets. Permissions can be assigned by role, user, or group. Enterprise customers can integrate with existing identity management systems and implement Single Sign-On (SSO) for seamless access management."
    },
    {
      question: "Which AI models does PlasticAnalytics use?",
      answer: "PlasticAnalytics uses proprietary AI models specifically trained on microplastics and environmental contaminants. We leverage both transformers and convolutional neural networks optimized for spectral data analysis. Our models are trained on our extensive spectral library containing thousands of verified samples. We do not train our models on customer data unless explicitly permitted as part of a custom solution."
    }
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <div style={{ 
      maxWidth: '1200px', 
      margin: '0 auto', 
      padding: '40px 20px',
      color: 'white',
      fontFamily: 'Helvetica, sans-serif',
    }}>
      <h2 style={{ 
        fontSize: '2.5rem', 
        marginBottom: '40px',
        fontWeight: 'normal'
      }}>
        FAQ
      </h2>
      
      <div style={{ marginBottom: '40px' }}>
        {faqData.map((faq, index) => (
          <FaqItem 
            key={index}
            question={faq.question}
            answer={faq.answer}
            isOpen={openIndex === index}
            onClick={() => toggleFaq(index)}
          />
        ))}
      </div>
    </div>
    
  );
};

export default FaqComponent;